<template>
  <div class="bg-gray-50 min-h-screen">
    <div class="max-w-4xl mx-auto px-4 py-12">
      <div class="mb-6">
        <button class="flex items-center gap-2 text-sm font-medium text-gray-600 hover:text-gray-900">
          <ArrowLeft class="h-4 w-4" />
          Back to Jobs
        </button>
      </div>

      <div class="bg-white border border-gray-200 rounded-lg shadow-sm">
        <div class="h-48 bg-gray-200 rounded-t-lg">
          <img :src="job.company.heroImage" class="w-full h-full object-cover rounded-t-lg" alt="Company Image">
        </div>
        <div class="p-6 md:p-8 relative">
          <div class="absolute top-0 left-8 -translate-y-1/2">
            <img :src="job.company.logo" class="h-20 w-20 rounded-full bg-white border-4 border-white shadow-md" />
          </div>

          <div class="pt-12 flex flex-col md:flex-row items-start justify-between">
            <div class="flex-1 mb-4 md:mb-0">
              <h1 class="text-3xl font-bold text-gray-900 mb-2">{{ job.title }}</h1>
              <div class="flex items-center gap-2 text-sm text-gray-600">
                <a href="#" class="font-medium text-gray-800 hover:underline">{{ job.company.name }}</a>
                <span>•</span>
                <span>{{ job.location }}</span>
              </div>
            </div>
            <div class="flex-shrink-0 w-full md:w-auto flex items-center gap-3">
              <button class="w-full sm:w-auto text-center px-5 py-2.5 bg-gray-100 text-gray-800 font-semibold text-sm rounded-md hover:bg-gray-200">
                Save
              </button>
              <button class="w-full sm:w-auto text-center px-5 py-2.5 bg-blue-600 text-white font-semibold text-sm rounded-md shadow-sm hover:bg-blue-700">
                Apply Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="my-8 p-6 bg-white border border-gray-200 rounded-lg">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
          <div>
            <span class="text-xs text-gray-500 block">Salary</span>
            <span class="font-semibold text-gray-800">{{ job.salary }}</span>
          </div>
          <div>
            <span class="text-xs text-gray-500 block">Job Type</span>
            <span class="font-semibold text-gray-800">{{ job.workType }}</span>
          </div>
          <div>
            <span class="text-xs text-gray-500 block">Category</span>
            <span class="font-semibold text-gray-800">{{ job.category }}</span>
          </div>
          <div>
            <span class="text-xs text-gray-500 block">Posted</span>
            <span class="font-semibold text-gray-800">{{ job.postedDate }}</span>
          </div>
        </div>
      </div>

      <div class="bg-white border border-gray-200 rounded-lg p-6 md:p-8">
        <div class="prose prose-sm max-w-none prose-h2:font-semibold prose-headings:text-gray-800 prose-p:text-gray-600 prose-ul:text-gray-600">
          <h2>About the Role</h2>
          <p>{{ job.description }}</p>
          
          <h2>Key Responsibilities</h2>
          <ul>
            <li v-for="task in job.role.tasks" :key="task">{{ task }}</li>
          </ul>

          <h2>About {{ job.company.name }}</h2>
          <p>{{ job.company.about }}</p>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { ArrowLeft } from 'lucide-vue-next';

const job = ref({
  title: 'Educator',
  company: {
    name: 'Goodstart Early Learning',
    logo: 'https://via.placeholder.com/80',
    heroImage: 'https://via.placeholder.com/1200x200',
    about: 'At Goodstart, we’re not just offering jobs; we’re shaping futures. Whether you’re a seasoned professional in early childhood education or just embarking on your journey, we have incredible opportunities tailored just for you.'
  },
  location: 'Cheltenham, Melbourne VIC',
  postedDate: '19h ago',
  category: 'Education & Training',
  workType: 'Full-time',
  salary: '$32.43 - $36.53 p/h',
  description: 'As a Goodstart Educator, you’ll become a vital part of our team, working alongside Senior Educators and our Educational Leader to craft and enhance exceptional learning programs for our children. Your dedication to safety and inclusivity will ensure every child thrives and feels valued in their learning experiences.',
  role: {
    tasks: [
      'Create and maintain a safe, healthy and welcoming environment for children.',
      'Develop strong relationships with families and the community.',
      'Contribute to the development and implementation of the educational program.',
      'Actively support the health and wellbeing of all children at the centre.'
    ]
  }
});
</script>